import { TextField, InputAdornment, IconButton } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const ChatInputField = ({
  userMessage,
  handleInputChange,
  sendUserMessage,
  placeholder = 'Ask something...',
  disabled = false,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      sendUserMessage();
    }
  };

  return (
    <TextField
      variant="outlined"
      size="medium"
      placeholder={placeholder}
      value={userMessage}
      onChange={handleInputChange}
      onKeyDown={handleKeyDown}
      fullWidth
      disabled={disabled}
      autoComplete="off"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => sendUserMessage()}
              edge="end"
              sx={{
                color: 'inherit',
                '&:hover': {
                  color: '#4880EC',
                },
              }}
            >
              <SendIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default ChatInputField;
